<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      row-id="quotationCode"
      >
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.quotationStatus === 'Y' ? 'success' : 'info'"
        >
          {{ row.quotationStatusName }}
        </el-tag>
      </template>

      <template v-slot:opt="{ row }">
        <div>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                fromLoad('edit', row)
              "
              v-if="allow('M')"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('tips_export') || '导出'"
            placement="top"
          >
            <i
              class="el-icon-download tool-btn"
              @click="
                showExportTemplateList(row)
              "
              v-if="allow('M')"
            ></i>
          </el-tooltip>

        </div>
      </template>

      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>

    <el-dialog
      ref="formDialog"
      :title="$l('tips_export_title') || '选择导出模板'"
      :visible.sync="exportTemplateVisible"
      :before-close="showExportTemplateCancel"
      :close-on-click-modal="false"
      width="950px"
    >
      <page-list ref="listTable" @export="exportExcel"></page-list>
    </el-dialog>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'

export default {
  mixins:[TableAutoHeight],
  props: {
    tablePage: {
      default: null,
      type: Object
    },
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  components: {
    PageList: () => import('./components/list')
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => {
            this.$emit('submit')
          }
        },
        zoom: true,
        custom: true
      },
      tableColumn:[
        {
          field: 'seq',
          width: 50,
          fixed: 'left',
          align: 'center',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'right',
          width: 80,
          slots: {
            default: 'opt'
          }
        },
        {
          field: 'quotationNo',
          width: 180,
          title: this.$l("table_head_quotationNo") || "报价单编号",
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          align: 'left'
        },
        {
          field: 'custName',
          minWidth: 180,
          title: this.$l("table_head_customerName") || "客户名称",
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          align: 'left'
        },
        {
          field: 'prjTitle',
          minWidth: 180,
          title: this.$l("table_head_correspondingProjectName") || "对应项目名称",
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          align: 'left'
        },
        {
          field: 'quotationDate',
          width: 130,
          title: this.$l("table_head_quotationDate") || "报价日期",
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          align: 'left'
        },
        {
          field: 'quotationExpiryDate',
          width: 130,
          title: this.$l("table_head_closingDate") || "截止日期",
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          align: 'left'
        },
        {
          field: 'quotationStatus',
          width: 90,
          title: this.$l('table_head_quotationStatus') || '有效状态',
          align: 'center',
          slots: { default: 'status' }
        },
        {
          field: 'versionNumber',
          width: 100,
          title: this.$l("table_head_currentVersionNumber") || "当前版本号",
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          align: 'left'
        },
      ],
      rowData: {}, // 点击导出时记录当前行数据
      exportTemplateVisible: false, // 导出模板列表弹框
     
      quotationStatusForm: {
        quotationStatus: '',
        quotationCode: ''
      }
    }
  },
  methods: {
    // 加载表单
    fromLoad(ref, val = '') {
      this.$router.push({
        name: 'personal-myQuotation-edit',
        params: {
          pageType: ref,
          quotationCode: val.quotationCode
        }
      })
    },
    saveSuccess() {
      this.cancel()
      this.$emit('submit')
    },
    cancel() {
      this.formOption.dialogFormVisible = false
    },
    updateQuotationStatus(val) {
      const data = this.tableData[val]
      this.quotationStatusForm.quotationCode = data.quotationCode
      let text = ''
      if (data.quotationStatus === 'Y') {
        text = '新增'
        this.quotationStatusForm.quotationStatus = 'N'
      } else {
        text = '已报价'
        this.quotationStatusForm.quotationStatus = 'Y'
      }
      this.$confirm('确认要改为‘‘' + text + '’’状态吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.save(this.quotationStatusForm)
        })
        .catch(() => {
          this.formReset()
        })
    },
    save(params) {
      this.$api.myQuotationMainSaveApi(params).then(() => {
        this.$message({
          showClose: true,
          message: this.$l("INDEX.tips_save_ok") || "保存成功",
          type: 'success'
        })
        this.formReset()
        this.$emit('submit')
      })
    },
    showExportTemplateList(row) {
      // 显示模板列表弹框
      this.exportTemplateVisible = true
      this.rowData = row
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.listTable.loadData()
      }, 0)
    },
    showExportTemplateCancel() {
      // 关闭模板列表弹框
      this.exportTemplateVisible = false
      this.rowData = {}
    },
    exportExcel(templateRow) {
      let param = {
        quotationCode: this.rowData.quotationCode,
        templateCode: templateRow.templateCode
      }

      var quotationNo = this.rowData.quotationNo
      var custName = this.rowData.custName
      var url = '/export/quotaionExport/execExport'
      var suffix = '.xlsx'
      if (templateRow.templateFileDesc.indexOf('PPT') !== -1) {
        url = '/export/quotationPptExport/execExport'
        suffix = '.pptx'
      }
      this.$api.exportExcel(url, param).then((res) => {
        const content = res
        var responseType = res.type
        const blob = new Blob([content], {
          type: responseType
        })
        if (
          res.type !== 'application/vnd.ms-excel' &&
          res.type !== 'application/octet-stream' &&
          res.type !== 'text/xml'
        ) {
          var reader = new FileReader()
          reader.readAsText(blob, 'utf-8')
          var _this = this
          reader.onload = function() {//e
            var resultJson = JSON.parse(reader.result)
            _this.$message.error(resultJson.msg)
          }
          return
        }
        var fileName = custName + quotationNo + suffix
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
      // 关闭模板列表弹框
      this.showExportTemplateCancel()
    },
    formReset() {
      this.quotationDateForm = {
        quotationDate: '',
        quotationCode: ''
      }
      this.quotationExpiryDateForm = {
        quotationExpiryDate: '',
        quotationCode: ''
      }
      this.quotationStatusForm = {
        quotationStatus: '',
        quotationCode: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.goods-edit {
  padding-left: 5px;
  font-size: 13px;
  color: $color-info;
  &:hover {
    cursor: pointer;
    color: $color-primary;
  }
}
.active {
  display: none;
}
.action:hover .active {
  display: inline;
}
</style>
